import { useOrganisation } from '@my/directory-api/hooks';

/**
 * The organisation's shipping-integration setting, held by Directory as
 * `TmsShippingIntegrationJson` (`{ "enabled": true }`) and written only by
 * Stratum support. Off is the default: a missing key, a null column, an
 * organisation still loading, all read as off.
 */
export interface ShippingIntegration {
  /** Crossings may be booked through the ferry service (where the organisation holds an account at the carrier). */
  enabled: boolean;
}

export const SHIPPING_INTEGRATION_DEFAULTS: ShippingIntegration = { enabled: false };

export function parseShippingIntegration(json: string | null | undefined): ShippingIntegration {
  if (!json) return { ...SHIPPING_INTEGRATION_DEFAULTS };
  try {
    const raw = JSON.parse(json) as Record<string, unknown>;
    return {
      enabled:
        typeof raw.enabled === 'boolean' ? raw.enabled : SHIPPING_INTEGRATION_DEFAULTS.enabled,
    };
  } catch {
    return { ...SHIPPING_INTEGRATION_DEFAULTS };
  }
}

export function serialiseShippingIntegration(value: ShippingIntegration): string {
  return JSON.stringify({ enabled: value.enabled });
}

/** The setting as the booking screens read it: off until support turns it on. */
export function useShippingIntegration(
  organisationId: string | null,
): ShippingIntegration & { isPending: boolean } {
  const query = useOrganisation(organisationId);
  return {
    ...parseShippingIntegration(query.data?.tmsShippingIntegrationJson),
    isPending: query.isPending,
  };
}
